import { Route } from "react-router-dom";
import RequireAuth from "../Auth/RequireAuth";
import SecuredRoute from "../components/common/VFX-UI/SecuredRoute/SecuredRoute";
import {
    permissions,
} from "../utility/helpers/claimHelper";
import CampaignsContainer from "../components/Campaign/CampaignContainer";
import { default as HistoricCampaignContainer } from "../components/Employee/Pledge/Campaign/CampaignContainer";
import ContributionByCheck from "../components/Contribution/ContributionByCheck";
import EmployeeImport from "../components/Employee/Import/ImportContainer";
import EmployeeContainer from "../components/Employee/EmployeeContainer";
import DonorsContainer from "../components/Campaign/Donors/DonorsContainer";
import { PledgeFormContainer, PledgeSuccess } from "../components/Employee/Pledge";

export default (
    <>
        <Route
            path="/campaign"
            element={
                <RequireAuth>
                    <SecuredRoute requiredPermission={permissions.MANAGE_CAMPAIGNS}>
                        <CampaignsContainer />
                    </SecuredRoute>
                </RequireAuth>
            }
        />
        <Route
            path="/active-campaigns"
            element={
                <RequireAuth>
                    <HistoricCampaignContainer activeCampaigns={true} />
                </RequireAuth>
            }
        />
        <Route
            path="/past-campaigns"
            element={
                <RequireAuth>
                    <HistoricCampaignContainer activeCampaigns={false} />
                </RequireAuth>
            }
        />
        <Route
            path="/contributionsbycheck"
            element={
                <RequireAuth>
                    <SecuredRoute requiredPermission={permissions.VIEW_CONTRIBUTIONS_BY_CHECK}>
                        <ContributionByCheck />
                    </SecuredRoute>
                </RequireAuth>
            }
        />
        <Route
            path="/employee-upload"
            element={
                <RequireAuth>
                    <SecuredRoute requiredPermission={permissions.IMPORT_EMPLOYEE_DATA}>
                        <EmployeeImport />
                    </SecuredRoute>
                </RequireAuth>
            }
        />
        <Route
            path="/employees"
            element={
                <RequireAuth>
                    <SecuredRoute requiredPermission={permissions.MANAGE_EMPLOYEES}>
                        <EmployeeContainer />
                    </SecuredRoute>
                </RequireAuth>
            }
        />
        <Route
            path="/pledge/:campaignId"
            element={
                <RequireAuth>
                    <PledgeFormContainer />
                </RequireAuth>
            }
        />
        <Route
            path="/pledge-success/:campaignId"
            element={
                <RequireAuth>
                    <PledgeSuccess />
                </RequireAuth>
            }
        />
        <Route
            path="/donors/:id"
            element={
                <RequireAuth>
                    <SecuredRoute
                        requiredPermission={[
                            permissions.MANAGE_CAMPAIGNS,
                            permissions.MANAGE_ORGANIZATION,
                            permissions.CORPORATE_USER,
                        ]}
                    >
                        <DonorsContainer />
                    </SecuredRoute>
                </RequireAuth>
            }
        />
    </>
);
